import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ReactNode } from "react";

interface MetricWithTooltipProps {
  label: string;
  value: string | number;
  tooltip: string;
  icon?: any;
  children?: ReactNode;
}

export const MetricWithTooltip = ({ 
  label, 
  value, 
  tooltip, 
  icon: Icon,
  children
}: MetricWithTooltipProps) => (
  <div className="space-y-2">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
        <span className="font-medium">{label}</span>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button className="focus:outline-none">
                <HelpCircle className="h-4 w-4 text-muted-foreground hover:text-primary transition-colors" />
              </button>
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              <p className="text-sm">{tooltip}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <span className="text-2xl font-bold">{value}</span>
    </div>
    {children}
  </div>
);
